import React, { useRef } from "react";
import { TextInput as RNTextInput, View } from "react-native";

import Icon from "$src/core/components/atoms/Icon";
import type { TextInputProps } from "$src/core/components/atoms/TextInput/types";

import $ from "./TextInput.styles";

const TextInput: React.FC<TextInputProps> = ({
  children,
  style,
  contentContainerStyle,
  secureTextEntry,
  isRounded,
  icon,
  ...restProps
}) => {
  $.useVariants({ isRounded, withIcon: !!icon });

  const inputRef = useRef<RNTextInput | null>(null);

  return (
    <View style={[$.container, style]}>
      {icon && <Icon name={icon} style={$.icon} />}
      <RNTextInput
        ref={inputRef}
        style={[$.input, contentContainerStyle]}
        placeholderTextColor={$.inputPlaceholder.color}
        secureTextEntry={secureTextEntry}
        {...restProps}
      />
    </View>
  );
};

export default TextInput;
